import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface PrintOptions {
  includeQrCode: boolean;
  includeTableInfo: boolean;
  includeFloorInfo: boolean;
  includeInstructions: boolean;
  includeTitle: boolean;
}

@Component({
  selector: 'app-qr-print-options-dialog',
  templateUrl: './qr-print-options-dialog.component.html',
  styleUrls: ['./qr-print-options-dialog.component.scss']
})
export class QrPrintOptionsDialogComponent implements OnInit {

  printOptions: PrintOptions = {
    includeQrCode: true,
    includeTableInfo: true,
    includeFloorInfo: true,
    includeInstructions: true,
    includeTitle: true
  };
  constructor(
    public dialogRef: MatDialogRef<QrPrintOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { isMultiple: boolean },
    private _translate: TranslateService
  ) { }
  ngOnInit(): void {
    // Set dialog direction based on current language
    this.dialogRef.updateSize();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onPrint(): void {
    this.dialogRef.close(this.printOptions);
  }

  selectAll(): void {
    Object.keys(this.printOptions).forEach(key => {
      this.printOptions[key] = true;
    });
  }

  deselectAll(): void {
    Object.keys(this.printOptions).forEach(key => {
      if (key !== 'includeQrCode') { // QR code should always be included
        this.printOptions[key] = false;
      }
    });
  }
}
